import { api } from "./api";

export const salesBillApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSalesBill: builder.query({
      query: () => "api/Sales",
      providesTags: ["salesBill"],
    }),
    getSalesBillByDoc: builder.query({
      query: (docID) => `api/Sales?DocNumver=${docID}`,
      providesTags: ["salesBill"],
    }),
    addSalesBill: builder.mutation({
      query: (formData) => ({
        url: "api/Sales",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["salesBill"],
    }),
    editSalesBill: builder.mutation({
      query: (formData) => ({
        url: "api/Sales",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["salesBill"],
    }),
    deleteSalesBill: builder.mutation({
      query: (docID) => ({
        url: `api/Sales?DocID=${docID}`,
        method: "DELETE",
      }),
      invalidatesTags: ["salesBill"],
    }),
  }),
});

export const {
  useGetSalesBillQuery,
  useLazyGetSalesBillByDocQuery,
  useAddSalesBillMutation,
  useEditSalesBillMutation,
  useDeleteSalesBillMutation,
} = salesBillApi;
